/* eslint-disable prettier/prettier */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import React, { useContext } from "react";
// import CustomTable from "../../../../components/common/Table";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import * as Sentry from "@sentry/react";
import StatusIcon from "../../../../assets/svg/Status";
import Table from "../../../../components/common/new/Table/Table";
import { MEMBER_SEAECH_TABLE_COL } from "../../../../contants/table/memberSearch";
// import tableStyle from "../../../../theme/styles/table";
// import DeleteIcon from "../../../../assets/svg/Delete";
import EyeIcon from "../../../../assets/svg/Eye";
import { AlertStatus, PERMISSIONS } from "../../../../contants";
import styles from "./MemberTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import Member from "../../../../services/api/member";
import HDCIcon from "../../../../assets/svg/HDCIcon";
import Reactivation from "../../../../assets/svg/Reactivation";
// import NewTable from "../../components/Newtable/NewTable";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
    padding: "5px",
  },
};

const ACTIVE = "ACTIVE";
const DEACTIVATED = "DEACTIVATED";

const getRows = ({
  searchData,
  onSelectMemberForTransfer,
  hasPermission,
  showStatusColumn,
  onMemberStatusToggle,
  onMemberStatusToggleForHelpDesk,
  isChapterSi,
  isHelpDesk,
  isAreaSi,
  isZoneSi,
  onEdit,
  onToggleHDC,
  isHelpDeskAdmin,
  onMemberReactivateToggle,
}) =>
  searchData?.map((memberInfo) => {
    const toast = useContext(ToastAlertContext);
    const transferEligibility = async () => {
      try {
        const response = await Member.transferEligibility({
          memberId: memberInfo.memberId,
        });
        if (response.message === "eligible") {
          onSelectMemberForTransfer(memberInfo, response.message);
        }
      } catch (error) {
        toast.show(error.message, AlertStatus.ERROR);

        Sentry.captureException(error);
      }
    };

    const handleTransferClick = () => {
      transferEligibility(); // Call the API when the "Apply" button is clicked
    };
    // To render the ManageAccountsIcon - Only for ChapterSI with specific positions
    const renderManageAccountsIcon = memberInfo?.positions?.some((position) => {
      const allowedPositionNames = [
        "District Chief",
        "District Chief - Deputy",
      ];
      return (
        allowedPositionNames.includes(position.name) &&
        position.positionType === "MAINLINE_POSITION"
      );
    });

    const nationalHDC = memberInfo?.positions?.some((position) => {
      const allowedPositionNames = [72, 71, 63, 58];
      // return allowedPositionNames.includes(position.name);
      return (
        allowedPositionNames.includes(position.id) &&
        position.positionType === "MAINLINE_POSITION"
      );
    });

    const areaHDC = memberInfo?.positions?.some((position) => {
      const allowedPositionNames = [62, 61];
      // return allowedPositionNames.includes(position.name);
      return (
        allowedPositionNames.includes(position.id) &&
        position.positionType === "MAINLINE_POSITION"
      );
    });

    const zoneHDC = memberInfo?.positions?.some((position) => {
      const allowedPositionNames = [59, 51];
      // return allowedPositionNames.includes(position.name);
      return (
        allowedPositionNames.includes(position.id) &&
        position.positionType === "MAINLINE_POSITION"
      );
    });

    const regionHDC = memberInfo?.positions?.some((position) => {
      const allowedPositionNames = [28, 27];
      // return allowedPositionNames.includes(position.name);
      return (
        allowedPositionNames.includes(position.id) &&
        position.positionType === "MAINLINE_POSITION"
      );
    });

    return (
      <TableRow>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {memberInfo.memberId}
          </Typography>{" "}
        </TableCell>
        {/* <TableCell style={tabelCellWidth.medium}>
          <a
            href={`/member/details/${memberInfo.memberId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              marginLeft: "20px",
              color: "rgba(118, 24, 32, 0.87)",
              fontSize: "0.875rem",
              fontWeight: 600,
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            {memberInfo.fullName}
          </a>{" "}
          <br />
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <LocationOnIcon style={{ fontSize: "1rem", color: "#777" }} />
            <Typography
              variant="caption"
              sx={{ color: "#1976d2", fontWeight: 500 }}
            >
              {memberInfo?.positions
                ?.filter((p) => p.positionType === "MAINLINE_POSITION")
                .map((p) => p.name)
                .join(", ")}
            </Typography>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo.addressLine1}
            </Typography>
          </div>
        </TableCell> */}
        <TableCell style={tabelCellWidth.medium}>
          {/* Name */}
          <a
            href={`/member/details/${memberInfo.memberId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "rgba(118, 24, 32, 0.9)",
              fontSize: "0.9rem",
              fontWeight: 600,
              textDecoration: "none",
              display: "block",
            }}
          >
            {memberInfo.fullName}
          </a>

          {/* Position */}
          <div
            style={{
              color: "#043D90", // sky blue
              fontStyle: "italic",
              fontSize: "0.75rem",
              fontWeight: 500,
              letterSpacing: "0.3px",
              marginTop: "2px",
            }}
          >
            {memberInfo?.positions
              ?.filter(
                (p) =>
                  p.positionType === "MAINLINE_POSITION" ||
                  p.positionType === "DEPUTY_POSITION"
              )
              ?.sort((a, b) => {
                if (a.positionType === "MAINLINE_POSITION") return -1;
                if (b.positionType === "MAINLINE_POSITION") return 1;
                return 0;
              })
              ?.map((p) => p.name)
              .join(" / ")}
          </div>

          {/* Address */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "0.75rem",
              color: "#070000ff",
            }}
          >
            <LocationOnIcon style={{ fontSize: "0.9rem", color: "#000000" }} />
            <span>
              {[
                memberInfo.addressLine1,
                memberInfo.cityName,
                memberInfo.stateName,
              ]
                .filter(Boolean) // null / undefined / empty remove
                .map((str) => str.trim().replace(/,+$/, "")) // trailing commas remove
                .join(", ")}
            </span>
          </div>
        </TableCell>

        <TableCell style={tabelCellWidth.medium}>
          {/* <PhoneIcon style={{ fontSize: "0.9rem", color: "#000000", flexShrink: 0 }} />
          <Typography style={styles.typoghrphyStyle}>
            {" "}
            {memberInfo.mobileNumber}
          </Typography>{" "} */}
          <div
            style={{
              display: "flex",
              gap: "6px",
              fontSize: "0.75rem",
              color: "#070000ff",
            }}
          >
            <PhoneIcon style={{ fontSize: "0.9rem", color: "#000000" }} />
            <span>{memberInfo.mobileNumber}</span>
          </div>

          {/* <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "4px",
              flexWrap: "wrap",
              maxWidth: "100%",
              wordBreak: "break-word",
            }}
          >
            <EmailIcon
              style={{ fontSize: "0.9rem", color: "#000000", flexShrink: 0 }}
            />
            <Typography style={{ ...styles.typoghrphyStyle, flex: 1 }}>
              {memberInfo?.emailId || "-"}
            </Typography>
          </div> */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "0.75rem",
              color: "#070000ff",
            }}
          >
            <EmailIcon style={{ fontSize: "0.9rem", color: "#000000" }} />
            <span>{memberInfo.emailId}</span>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {memberInfo?.divisionName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.medium, verticalAlign: "top" }}>
          <Typography
            style={{
              ...styles.typoghrphyStyle,
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            {[
              memberInfo?.areaName,
              memberInfo?.zoneName,
              memberInfo?.regionName,
              memberInfo?.chapterName,
              memberInfo?.districtName,
              memberInfo?.blockName,
            ]
              .filter(Boolean)
              .join(" / ") || "-"}
          </Typography>
        </TableCell>

        {showStatusColumn && (
          <TableCell style={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              <StatusIcon label={memberInfo.status} />
            </div>
          </TableCell>
        )}
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <div style={styles.actionButtons}>
            <a
              href={`/member/details/${memberInfo.memberId}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "inline-flex" }}
            >
              <EyeIcon style={{ ...styles.actionIcon, marginTop: "4px" }} />
            </a>

            {(isHelpDesk &&
              nationalHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_HELPDESK)) ||
            (isHelpDesk &&
              areaHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_HELPDESK)) ||
            (isHelpDeskAdmin &&
              nationalHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_HELPDESK_ADMIN)) ||
            (isHelpDeskAdmin &&
              areaHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_HELPDESK_ADMIN)) ||
            (isHelpDesk &&
              zoneHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_HELPDESK)) ||
            (isHelpDesk &&
              regionHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_HELPDESK)) ||
            (isHelpDeskAdmin &&
              zoneHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_HELPDESK_ADMIN)) ||
            (isHelpDeskAdmin &&
              regionHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_HELPDESK_ADMIN)) ||
            (isAreaSi &&
              zoneHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_AREA)) ||
            (isZoneSi &&
              regionHDC &&
              hasPermission(PERMISSIONS.CREATE_HDC_ZONE)) ? (
              // <Tooltip title="HDC">
              <div style={styles.actionButtons}>
                <HDCIcon
                  style={{ ...styles.actionIcon }}
                  onClick={() => onToggleHDC(memberInfo)}
                />
              </div>
            ) : // {/* </Tooltip> */}
            null}
            {isChapterSi && renderManageAccountsIcon && (
              <Tooltip title="Edit Roles">
                <ManageAccountsIcon
                  style={{ ...styles.actionIcon, marginTop: "4px" }}
                  onClick={() => onEdit(memberInfo)}
                />
              </Tooltip>
            )}
            {hasPermission(PERMISSIONS.INITIATE_TRANSFER_MEMBER) && (
              <Tooltip title="Transfer">
                <TransferWithinAStationIcon
                  style={{ ...styles.actionIcon }}
                  onClick={() => handleTransferClick()}
                />
              </Tooltip>
            )}
          </div>
          {/* <DeleteIcon style={styles.actionIcon} /> */}
          {hasPermission(PERMISSIONS.DEACTIVATE_MEMBER) &&
            memberInfo.status === ACTIVE && (
              <DoNotDisturbIcon
                style={{
                  ...styles.actionIcon,
                  color: "#7DEB6D",
                  fontSize: "1.5rem",
                }}
                onClick={() => onMemberStatusToggle(memberInfo)}
              />
            )}
          {(isHelpDesk || isHelpDeskAdmin) && memberInfo.status === ACTIVE && (
            <DoNotDisturbIcon
              style={{
                ...styles.actionIcon,
                color: "#7DEB6D",
                fontSize: "1.5rem",
              }}
              onClick={() => onMemberStatusToggleForHelpDesk(memberInfo)}
            />
          )}
          {memberInfo.status === DEACTIVATED &&
            hasPermission(PERMISSIONS.REACTIVATE_MEMBER) && (
              <Tooltip title="Reactivate">
                <Box>
                  <Reactivation
                    style={{
                      ...styles.actionIcon,
                      marginTop: "8px",
                    }}
                    onClick={() => onMemberReactivateToggle(memberInfo)}
                  />
                </Box>
              </Tooltip>
            )}
        </TableCell>
      </TableRow>
    );
  });

function MemberTable({
  searchData,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onMemberStatusToggleForHelpDesk,
  onSelectMember,
  onSelectMemberForMobile,
  hasPermission,
  showStatusColumn,
  onEdit,
  onToggleHDC,
  isChapterSi,
  isHelpDesk,
  isAreaSi,
  isZoneSi,
  isHelpDeskAdmin,
  onMemberReactivateToggle,
  isMobile,
}) {
  const columns = MEMBER_SEAECH_TABLE_COL.map((col) => ({
    ...col,
    label: col.displayName,
  })).filter(
    (col) =>
      ![
        "areaName",
        "zoneName",
        "regionName",
        "chapterName",
        "districtName",
        "blockName",
        "Organization Structure",
      ].includes(col.key)
  );
  if (!showStatusColumn) {
    const index = columns.findIndex((col) => col.key === "status");
    if (index !== -1) columns.splice(index, 1);
  }

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          onSelectMemberForTransfer,
          onSelectMember,
          onSelectMemberForMobile,
          hasPermission,
          onMemberStatusToggle,
          onMemberStatusToggleForHelpDesk,
          showStatusColumn,
          isChapterSi,
          isHelpDesk,
          isAreaSi,
          isZoneSi,
          onEdit,
          onToggleHDC,
          isHelpDeskAdmin,
          onMemberReactivateToggle,
          isMobile,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          // textAlign: "left",
        }}
      />
    </div>
  );
}

export default MemberTable;
